import { render } from "./OvalButton.vue?vue&type=template&id=c61f8580&scoped=true"
import script from "./OvalButton.vue?vue&type=script&lang=js"
export * from "./OvalButton.vue?vue&type=script&lang=js"

import "./OvalButton.vue?vue&type=style&index=0&id=c61f8580&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61f8580"]])

export default __exports__